export const ASSIST_LIST_PAGE_SIZE = 8;

export function pageSlice<T>(items: T[], page: number, pageSize = ASSIST_LIST_PAGE_SIZE): T[] {
    const start = Math.max(0, page) * pageSize;
    return items.slice(start, start + pageSize);
}

export function pageCount(total: number, pageSize = ASSIST_LIST_PAGE_SIZE): number {
    return Math.max(1, Math.ceil(Math.max(0, total) / pageSize));
}
